import { useCallback, useRef, useState } from "react";

/** Open state plus an anchor ref, the pair every Popover consumer needs. */
export function useDisclosure<T extends HTMLElement = HTMLButtonElement>(initial = false) {
  const [open, setOpen] = useState(initial);
  const anchorRef = useRef<T>(null);
  const toggle = useCallback(() => setOpen((v) => !v), []);
  const close = useCallback(() => setOpen(false), []);
  const show = useCallback(() => setOpen(true), []);
  return { open, setOpen, toggle, close, show, anchorRef };
}
